import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Vault Video'),
    sidebar: false,
    steps: [
        {
            key: 'landing',
            state: 'holding.dashboard.governance.vault-video.landing',
            heading: gettext('Vault Video'),
        },
        {
            key: 'details',
            state: 'holding.dashboard.governance.vault-video.video',
            heading: gettext('Vault Video'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/governance/states/governance/vault-video/vault-video-flow.ts